import { render, staticRenderFns } from "./PartNotFaultyModal.vue?vue&type=template&id=40cbe9e6&scoped=true&"
import script from "./PartNotFaultyModal.vue?vue&type=script&lang=js&"
export * from "./PartNotFaultyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cbe9e6",
  null
  
)

export default component.exports